<template>
    <vs-prompt buttons-hidden	class="large" :title="title" :active="active" @close="close">

      <template v-if="type === 'assign'">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input
              label-placeholder="البريد الالكتروني"
              name="email"
              data-vv-as="هذا الحقل"
              v-validate="'required|email'"
              icon-pack="feather"
              icon="icon-mail"
              icon-no-border
              v-model="formData.email"
              autocomplete="false"
              class="w-full" />

            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>

      </template>
      <template v-if="type === 'add'">
        <h4 class="mb-4">قم بادخال بيانات المستخدم</h4>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              label-placeholder="الإسم"
              name="first_name"
              data-vv-as="هذا الحقل"
              v-validate="'required|alpha_spaces|min:2'"
              v-model="formData.first_name"
              class="w-full" />

            <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              label-placeholder="اسم الأب"
              name="middle_name"
              data-vv-as="هذا الحقل"
              v-validate="'required|alpha_spaces|min:2'"
              v-model="formData.middle_name"
              class="w-full" />

            <span class="text-danger text-sm" v-show="errors.has('middle_name')">{{ errors.first('middle_name') }}</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              label-placeholder="اللقب"
              name="last_name"
              data-vv-as="هذا الحقل"
              v-validate="'required|alpha_spaces|min:2'"
              v-model="formData.last_name"
              class="w-full" />

            <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
          </div>
        </div>
        <div class="vx-row mb-base">
          <div class="vx-col w-full">
            <vs-input
              label-placeholder="البريد الالكتروني"
              name="email"
              data-vv-as="هذا الحقل"
              v-validate="'required|email'"
              icon-pack="feather"
              icon="icon-mail"
              icon-no-border
              v-model="formData.email"
              autocomplete="false"
              class="w-full" />

            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>
      </template>
      <vx-card class="mb-4" no-shadow card-border>
        <div class="mb-2 flex items-end">
          <feather-icon class="mr-2" icon="LockIcon" />
          <span class="font-medium text-lg leading-none">الصلاحيات</span>
        </div>
        <vs-divider />
        <table class="w-full">
          <tr>
            <th class="font-semibold text-base text-left px-3 py-2">الصلاحية</th>
            <th class="font-semibold text-base text-left px-3 py-2">عرض</th>
            <th class="font-semibold text-base text-left px-3 py-2">إضافة</th>
            <th class="font-semibold text-base text-left px-3 py-2">تعديل</th>
            <th class="font-semibold text-base text-left px-3 py-2">حذف</th>
          </tr>
          <tr>
            <td class="px-3 py-2">إدارة الطلبة</td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="view_students"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="add_students"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="update_students"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="delete_students"></vs-checkbox></td>
          </tr>
          <tr>
            <td class="px-3 py-2">إدارة أعضاء هيئة تدريس</td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="view_teachers"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="assign_teachers"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="update_teachers"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="delete_teachers"></vs-checkbox></td>
          </tr>
          <tr>
            <td class="px-3 py-2">إدارة المواد الدراسية</td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="view_courses"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="add_courses"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="update_courses"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="delete_courses"></vs-checkbox></td>
          </tr>
          <tr>
            <td class="px-3 py-2">إدارة الصلاحيات</td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="view_roles"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="add_roles"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="update_roles"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="delete_roles"></vs-checkbox></td>
          </tr>
          <tr>
            <td class="px-3 py-2">إدارة الفصول الدراسية</td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="view_terms"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="add_terms"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="update_terms"></vs-checkbox></td>
            <td class="px-3 py-2"><vs-checkbox v-model="formData.roles" name="roles" vs-value="delete_terms"></vs-checkbox></td>
          </tr>
        </table>
      </vx-card>
      <vx-divider />
      <div class="flex justify-end">
        <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
        <vs-button @click="submitClicked">حفظ</vs-button>
      </div>
    </vs-prompt>
</template>

<script>
    import adminsAPI from '@/api/admin/adminsAPI'

    export default {
        name: 'UserRoleForm',
        props: {
            data: {
                required: true,
                type: Object
            },
            active: {
                required: true,
                default: false,
                type: Boolean
            },
            type: {
                type: String,
                default: 'add'
            }
        },
        watch: {
            active(val){
                if(!val) return

                this.intiValues()
                Object.assign(this.formData, this.data)
            }
        },
        computed: {
            title() {
                switch (this.type) {
                    case 'assign' : return 'تعيين صلاحيات إلى إستاذ'
                    case 'add' : return 'إضافة مستخدم'
                    case 'edit' : return `تعديل صلاحيات ${this.formData.first_name} ${this.formData.last_name}`
                    default : return ''
                }
            }
        },
        data () {
            return {
                formData: {
                    first_name:'',
                    middle_name:'',
                    last_name:'',
                    id:'',
                    email: '',
                    roles: []
                },
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        if(this.type === 'assign'){
                            this.assign()
                        } else if(this.type === 'add') {
                            this.add()
                        } else {
                            this.edit()
                        }
                    }
                })

            },
            edit(){
                adminsAPI.updateRole({user_id: this.formData.id, roles: this.formData.roles})
                    .then(response => {
                        this.$emit('submit', Object.assign({}, this.formData))
                        this.close()
                        this.$notifySuccess(response.successMessage)
                    })
                    .finally(() => this.$closeLoading())
            },
            add(){
                adminsAPI.addAdmin(this.formData)
                    .then(response => {
                        this.formData.id = response.data.id
                        this.$emit('submit', Object.assign({}, this.formData))
                        this.close()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(({errors}) => {
                        Object.keys(errors).forEach(key => {
                            this.$validator.errors.add({ field: key, msg: errors[key][0] })
                        })
                    })
                    .finally(() => this.$closeLoading())
            },
            assign() {
                adminsAPI.assignAdmin({ email: this.formData.email, roles: this.formData.roles })
                    .then((response) => {
                        let message = response.data.message
                        if(message === 'not_teacher'){
                            this.$notifyWarning('هذا الحساب ليس لإستاذ.')
                        } else if(message === 'exists') {
                            this.$notifyWarning('هذا الحساب لديه صلاحية المدير بالفعل.')
                        } else {
                            this.$emit('submit', Object.assign({}, response.data.user))
                            this.close()
                            this.$notifySuccess(response.successMessage)
                        }
                    })
                    .catch(response => {
                        if(response.status === 404){
                            this.$notifyError('البريد الإلكتروني الذي قمت بإدخالة ليس موجود.')
                        }
                    })
                    .finally(() => this.$closeLoading())
            },
            close(){
                this.$emit('update:active', false)
            },
            intiValues() {
                this.formData = {
                    first_name:'',
                    middle_name:'',
                    last_name:'',
                    id:'',
                    email: '',
                    roles: []
                }
                if(this.type === 'edit') {
                    this.$validator.pause()
                } else {
                    this.$validator.resume()
                    this.$validator.reset()
                }
            },
        },
    }
</script>
